<script setup>
import { ref, computed, watch } from 'vue';
import { useFieldsStore } from '@/stores/storeFieldData';
import { useValidation } from '@/utils/useValidataion';

const storeField = useFieldsStore();
const value = defineModel()
const { validation, isValid, isTouched, textError } = useValidation(value)


const errorText = ref(null)

const heightErrorText = computed(() => {
    if (errorText.value) {
        return errorText.value.offsetHeight;
    }
})

const props = defineProps({
    stateKey: {
        type: String,
    },
    placeholder: {
        type: String,
    },
    maxLength: {
        type: Number
    },
    readonly: {
        type: Boolean,
        default: false  
    },
})

const count = ref(props.maxLength);

watch( value, (newValue) => {
	count.value = props.maxLength - newValue.length;
});

const resizeMessage = (e) => {
	const textarea = e.target;
    textarea.style.minHeight = `auto`;
	const textareaHeight = textarea.scrollHeight;
	textarea.style.minHeight = `${textareaHeight}px`;
	textarea.style.transition = `min-height .2s linear`
}

</script>
<template>
    <label :class="['input']">
       
        <div class="input__holder --message" :class="[isTouched && (isValid ? 'valid' : 'not-valid')]">
            <textarea 
                :class="['input__field none-scrollbar', isTouched && (isValid ? 'valid' : 'not-valid') ]" 
                autocomplete="on"
                :maxlength="maxLength"
                @input="(e) => {storeField.updateFields(stateKey, 'title', value), resizeMessage(e), validation(stateKey)}" 
                @blur="() => readonly ? null : validation(stateKey)"
                v-model="value"
                :placeholder="placeholder"
                :readonly="readonly" 
                >                            
            </textarea>
            <span class="input__title"><slot></slot></span>
        </div>
        <span v-if="!readonly" class="input__counter"><i>{{ count }}</i>/<i>{{ maxLength }}</i></span>       
        <Transition>
            <span v-if="count === 0" class="input__error" ref="errorText" :style="{ bottom: `${(heightErrorText + 10) * -1}px` }">Не более {{ maxLength }} символов</span>
        </Transition>       
    </label>
</template>
<style lang='scss' scoped>
.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translate(-50%, 10px);
}
.v-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}
</style>